import Icon from "hardcover-ui/components/Icon";
import chevronRight from "icons/solid/chevron-right.svg";
import chevronLeft from "icons/solid/chevron-left.svg";
import TextLink from "hardcover-ui/components/TextLink";
import { SharedSerializersPagination } from "types/serializers";
import { usePage } from "@inertiajs/react";

export interface PaginationPageProps {
  [key: string]: unknown;
  pagination: SharedSerializersPagination;
}

export default function Pagination() {
  // if page has no pagination props and you use this component it'll break
  const { pagination } = usePage<PaginationPageProps>().props;
  const { currentPage, totalPages, url, params } = pagination;

  return (
    <div className="mt-8 flex flex-row justify-between px-2">
      {currentPage > 1 ? (
        <TextLink
          href={`${url}?page=${currentPage - 1}&${params}`}
          className="flex row items-center space-x-1"
          size="md"
        >
          <Icon icon={chevronLeft} size="sm" />
          <span>Previous</span>
        </TextLink>
      ) : (
        <span />
      )}
      {currentPage < totalPages ? (
        <TextLink
          href={`${url}?page=${currentPage + 1}${params ? `&${params}` : ''}`}
          className="flex row items-center space-x-1"
        >
          <span>Next</span>
          <Icon icon={chevronRight} />
        </TextLink>
      ) : (
        <span />
      )}
    </div>
  );
}
